// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1egHc","largestCol":"styles_largestCol__u5ScI","smallestCol":"styles_smallestCol__11jSF"};